export const MALES = [
  'akky',
  'aleksandr',
  'alexander',
  'aleksey',
  'alexey',
  'aleksei',
  'anatoly',
  'anatoliy',
  'anatoli',
  'anatolii',
  'andrey',
  'andrei',
  'anton',
  'arkady',
  'arkadiy',
  'artem',
  'artyom',
  'artur',
  'arsen',
  'arsenii',
  'boris',
  'david',
  'vadim',
  'valentin',
  'valeriy',
  'valerii',
  'valeriia',
  'vasily',
  'vasiliy',
  'vasili',
  'vasilii',
  'viktor',
  'victor',
  'vitaly',
  'vitaliy',
  'vitalii',
  'vladimir',
  'vladislav',
  'vyacheslav',
  'viacheslav',
  'gennady',
  'gennadiy',
  'gennadi',
  'georgy',
  'georgiy',
  'georgi',
  'georgii',
  'gennadii',
  'gleb',
  'grigory',
  'grigoriy',
  'grigori',
  'grigorii',
  'daniil',
  'danil',
  'danila',
  'denis',
  'dmitry',
  'dmitriy',
  'dmitri',
  'dmitrii',
  'yevgeny',
  'yevgeniy',
  'evgeny',
  'evgenii',
  'yegor',
  'egor',
  'zakhar',
  'zahar',
  'ivan',
  'igor',
  'ilya',
  'ilia',
  'innokenty',
  'innokentiy',
  'innokenti',
  'iosif',
  'kamil',
  'kirill',
  'konstantin',
  'lev',
  'leonid',
  'maksim',
  'maxim',
  'matvey',
  'matvei',
  'marat',
  'mark',
  'mikhail',
  'moisey',
  'nikita',
  'nikolay',
  'nikolai',
  'oleg',
  'pavel',
  'pyotr',
  'petr',
  'roman',
  'ruslan',
  'svyatoslav',
  'sviatoslav',
  'semyon',
  'semen',
  'sergey',
  'sergei',
  'stanislav',
  'stepan',
  'timofey',
  'timofei',
  'timur',
  'timour',
  'tikhon',
  'tihon',
  'fedor',
  'fyodor',
  'filipp',
  'philipp',
  'eduard',
  'edward',
  'eldar',
  'emil',
  'erik',
  'eric',
  'yuri',
  'yuriy',
  'yury',
  'iurii',
  'yakov',
  'iakov',
  'yan',
  'ian',
  'yaroslav',
  'iaroslav',
  'ellin',
] as const;
export const FEMALES = [
  'aleksandra',
  'alexandra',
  'alevtina',
  'alena',
  'alisa',
  'alina',
  'alla',
  'albina',
  'anastasia',
  'anastasiia',
  'anastasiya',
  'angelina',
  'anzhela',
  'anzhelika',
  'angela',
  'anna',
  'antonina',
  'arina',
  'valentina',
  'valeria',
  'valeriya',
  'varvara',
  'vasilisa',
  'vera',
  'veronika',
  'veronica',
  'viktoria',
  'viktoriya',
  'victoria',
  'viktoriia',
  'galina',
  'darya',
  'daria',
  'diana',
  'dina',
  'dinara',
  'yevgenia',
  'yevgeniya',
  'evgenia',
  'evgeniya',
  'yekaterina',
  'ekaterina',
  'yelena',
  'elena',
  'yelizaveta',
  'elizaveta',
  'zhanna',
  'zinaida',
  'zoya',
  'zoia',
  'inna',
  'irina',
  'kamilla',
  'karina',
  'kira',
  'klara',
  'clara',
  'kristina',
  'ksenia',
  'kseniya',
  'kseniia',
  'larisa',
  'lara',
  'lora',
  'leila',
  'leyla',
  'lidia',
  'lidiya',
  'lidiia',
  'lilia',
  'liliya',
  'liliia',
  'lia',
  'liya',
  'lyubov',
  'liubov',
  'lyudmila',
  'liudmila',
  'maya',
  'maia',
  'margarita',
  'rita',
  'marianna',
  'marina',
  'maria',
  'mariya',
  'mariia',
  'maryam',
  'mariam',
  'milana',
  'nadezhda',
  'nadezda',
  'natalya',
  'natalia',
  'nataliya',
  'nataliia',
  'nina',
  'oksana',
  'oxana',
  'olesya',
  'olesia',
  'olga',
  'polina',
  'raisa',
  'regina',
  'rimma',
  'rosa',
  'sabina',
  'svetlana',
  'snezhana',
  'sofya',
  'sofia',
  'sofiia',
  'taisiia',
  'tamara',
  'tatyana',
  'tatiana',
  'ulyana',
  'uliana',
  'ella',
  'elvira',
  'elina',
  'emma',
  'eva',
  'evgeniia',
  'yulia',
  'yuliya',
  'iuliia',
  'yana',
  'iana',
] as const;
export const MALES_RU = [
  'аккы',
  'александр',
  'алексей',
  'анатолий',
  'андрей',
  'антон',
  'аркадий',
  'артем',
  'артём',
  'артур',
  'арсен',
  'арсений',
  'борис',
  'давид',
  'дэвид',
  'вадим',
  'валентин',
  'валерий',
  'василий',
  'виктор',
  'виталий',
  'владимир',
  'владислав',
  'вячеслав',
  'геннадий',
  'георгий',
  'georgiy',
  'глеб',
  'григорий',
  'даниил',
  'данил',
  'данила',
  'денис',
  'дмитрий',
  'димитрий',
  'dmitri',
  'евгений',
  'егор',
  'захар',
  'иван',
  'игорь',
  'илья',
  'иннокентий',
  'иосиф',
  'камиль',
  'кирилл',
  'константин',
  'лев',
  'леонид',
  'максим',
  'матвей',
  'марат',
  'марк',
  'михаил',
  'моисей',
  'никита',
  'николай',
  'олег',
  'павел',
  'петр',
  'пётр',
  'роман',
  'руслан',
  'святослав',
  'семен',
  'семён',
  'сергей',
  'станислав',
  'степан',
  'тимофей',
  'тимур',
  'тихон',
  'федор',
  'фёдор',
  'филипп',
  'эдуард',
  'эльдар',
  'ильдар',
  'эмиль',
  'эрик',
  'юрий',
  'яков',
  'ян',
  'ярослав',
  'эллин',
] as const;
export const FEMALES_RU = [
  'александра',
  'алевтина',
  'алена',
  'алёна',
  'алиса',
  'алина',
  'алла',
  'альбина',
  'анастасия',
  'ангелина',
  'анжелла',
  'анна',
  'антонина',
  'арина',
  'валентина',
  'валерия',
  'варвара',
  'василиса',
  'вера',
  'вероника',
  'виктория',
  'галина',
  'дария',
  'дарья',
  'диана',
  'дина',
  'динара',
  'евгения',
  'екатерина',
  'елена',
  'елизавета',
  'жанна',
  'зинаида',
  'зоя',
  'инна',
  'ирина',
  'камилла',
  'карина',
  'кира',
  'клара',
  'кристина',
  'ксения',
  'лариса',
  'лара',
  'лора',
  'лейла',
  'лидия',
  'лилия',
  'лия',
  'любовь',
  'людмила',
  'майя',
  'маргарита',
  'рита',
  'марианна',
  'марина',
  'мария',
  'мариям',
  'марьям',
  'милана',
  'милена',
  'надежда',
  'наталья',
  'нина',
  'оксана',
  'олеся',
  'ольга',
  'полина',
  'раиса',
  'регина',
  'римма',
  'сабина',
  'светлана',
  'роза',
  'снежанна',
  'софия',
  'софья',
  'таисия',
  'тамара',
  'татьяна',
  'ульяна',
  'элла',
  'эльвира',
  'эмма',
  'элина',
  'ева',
  'юлия',
  'яна',
] as const;
